import { State } from '@progress/kendo-data-query';
import { Dispatch, FC, SetStateAction, useCallback, useMemo } from 'react';
import ClearFilters from 'src/assets/icons/ClearFilters';
import Button from 'src/components/design-system/Button';
import { initialDataState } from './MatchDocumentTable';

interface MatchDocumentTableToolBarProps {
  dataState: State;
  setDataState: Dispatch<SetStateAction<State>>;
}

const MatchDocumentTableToolBar: FC<MatchDocumentTableToolBarProps> = ({
  dataState,
  setDataState,
}) => {
  const isClearFilterDisabled = useMemo(
    () => !dataState.filter?.filters.length,
    [dataState.filter?.filters.length]
  );

  const clearFilter = useCallback(() => {
    setDataState(initialDataState);
  }, [setDataState]);

  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-2">
        <Button
          endIcon={<ClearFilters />}
          color="transparent"
          onClick={clearFilter}
          className={isClearFilterDisabled ? '!bg-transparent' : ''}
          disabled={isClearFilterDisabled}
        >
          Clear Filter
        </Button>
      </div>
    </div>
  );
};

export default MatchDocumentTableToolBar;
